let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("83W1e")).then(() => parcelRequire('b1t6C'));